module.exports = __webpack_public_path__ + "img/8-red-diamond.8511d8fc.png";